import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export default function ThreeReasons(){
    const { t } = useTranslation();
    const values=[
        {
            title:"Notre network",
            icon:"net.svg",
            icon_mobile:"net blue.svg",
            text:"LM Platinum Estates dispose d'un réseau national unique et a ainsi accès à un grand nombre d'acheteurs potentiels."
        },
        {
            title:"Notre service",
            icon:"serv.svg",
            icon_mobile:"serv blue.svg",
            text:"La compétence, l'exclusivité et la passion ainsi que notre service personnalisé et complet caractérisent la marque LM Platinum – du premier conseil individuel à la conclusion réussie d'un contrat."
        },
        {
            title:"Notre expertise",
            icon:"loc.svg",
            icon_mobile:"loc blue.svg",
            text:"Nos agents immobiliers disposent d'une expertise approfondie et d'une connaissance du marché dont vous bénéficierez en matière de concept de service fiable."
        },
    ];

    return(
        <>
            {!isMobile ? <img id="reasons-image" src="5379637510122105175.jpg"/> : ""}
            <div id='three-reasons-block' className="vertical-center-element">
                <div className="white-title-text" id='threereasons-title'>{t('Trois raisons pour lesquelles nous sommes le partenaire idéal pour vous')}</div>
                <div id="values-section">
                    {values.map(item=>
                        <div id="reasons-card">
                            <div id="value-title">
                                <img src={isMobile ? item.icon_mobile:item.icon}/>
                            </div>
                            <div id="value-text">
                                {t(item.text)}
                            </div>
                        </div>
                        )}
                </div>
            </div>
        </>
    )
}
